"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageModel = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var PageModel = (function (_super) {
    tslib_1.__extends(PageModel, _super);
    function PageModel() {
        var _this = _super.call(this) || this;
        _this._assetsProgress = 0;
        _this._gameStartedAtProgress = NaN;
        _this._windowFocusHandler = function (e) { return _this.windowFocusHandler(e); };
        _this._documentVisibilityHandler = _this.documentVisibilityHandler.bind(_this);
        _this._windowBlured = document.hidden || !document.hasFocus();
        ["blur", "focus"].forEach(function (e) {
            return window.addEventListener(e, _this._windowFocusHandler);
        });
        document.addEventListener("visibilitychange", _this._documentVisibilityHandler);
        return _this;
    }
    Object.defineProperty(PageModel.prototype, "assetsProgress", {
        get: function () {
            return this._assetsProgress;
        },
        set: function (value) {
            if (this.bus) {
                if (isNaN(this._gameStartedAtProgress)) {
                    this._gameStartedAtProgress = this.bus.loaded || 0;
                    if (typeof gsap !== "undefined") {
                        gsap.killTweensOf(this.bus);
                    }
                }
                this._assetsProgress = value;
                this.bus.loaded =
                    this._gameStartedAtProgress +
                        (100 - this._gameStartedAtProgress) * this._assetsProgress;
            }
        },
        enumerable: false,
        configurable: true
    });
    PageModel.prototype.isBusReadyAsync = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!((_a = this.bus) === null || _a === void 0 ? void 0 : _a.ready)) return [3, 2];
                        return [4, core_1.WaitAction.ms(10)];
                    case 1:
                        _b.sent();
                        return [3, 0];
                    case 2: return [2];
                }
            });
        });
    };
    Object.defineProperty(PageModel.prototype, "bus", {
        get: function () {
            return window.__diffbus;
        },
        enumerable: false,
        configurable: true
    });
    PageModel.prototype.windowFocusHandler = function (e) {
        switch (e.type) {
            case "focus":
                this.windowBlured = false;
                break;
            case "blur":
                this.windowBlured = true;
                break;
        }
    };
    PageModel.prototype.documentVisibilityHandler = function () {
        if (document.hidden) {
            this.windowBlured = true;
        }
        else {
            this.windowBlured = false;
        }
    };
    Object.defineProperty(PageModel.prototype, "windowBlured", {
        get: function () {
            return this._windowBlured;
        },
        set: function (value) {
            if (this._windowBlured !== value) {
                this._windowBlured = value;
                this.callPagePauseAction(this._windowBlured);
            }
        },
        enumerable: false,
        configurable: true
    });
    PageModel.prototype.callPagePauseAction = function (blured) {
        var _a;
        (_a = (0, core_1.lazyGet)(interfaces_1.TypesSocial.pauseAction)) === null || _a === void 0 ? void 0 : _a.run(blured);
    };
    PageModel.prototype.destroy = function () {
        var _this = this;
        ["blur", "focus"].forEach(function (e) {
            return window.removeEventListener(e, _this._windowFocusHandler);
        });
        document.removeEventListener("visibilitychange", this._documentVisibilityHandler);
        _super.prototype.destroy.call(this);
    };
    PageModel = tslib_1.__decorate([
        (0, inversify_1.injectable)(),
        tslib_1.__metadata("design:paramtypes", [])
    ], PageModel);
    return PageModel;
}(core_1.GlobalEventProvider));
exports.PageModel = PageModel;
//# sourceMappingURL=PageModel.js.map